<template>
    <div>
        <page-header :buttons="pageActions.buttons" :additional="pageActions.additional" @method="methodHandler">
            <template slot="title">Sections</template>
        </page-header>
        <pro-table
            :resource="resource"
            prefix="/configuration/"
            :fields="fields"
            :filters="filters"
            :filters-loading="filtersLoading"
            :limit="50"
            ref="datatable"
            class="px-6 pt-2"
            @action="actionHandler"
            table-class="text-xs"
            sort="name"
            direction="ASC"
            delete-label="name"
            :actions="actions"
        ></pro-table>
    </div>
</template>

<script>
    import DataTableSetup from '../../../mixins/DataTableSetup';

    export default {
        name: "Sections",
        mixins: [ DataTableSetup ],
        data: function() {
            return {
                resource: 'sections',
                numberOfFilters: 1,
                pageActions: {
                    buttons: [
                        {
                            label: 'New Section',
                            icon: 'plus',
                            type: 'router-link',
                            link: '/configuration/sections/create',
                            iconClass: 'text-green-600'
                        }
                    ],
                    additional: []
                },
                fields: [
                    {
                        name: 'Name',
                        column: 'name',
                        route: '/configuration/sections/{id}/edit',
                        linked: true,
                        sortCol: 'name',
                        hierarchy: true
                    },
                    {
                        name: 'Route',
                        column: 'route',
                    },
                    {
                        name: 'Icon',
                        column: 'icon',
                        icon: true,
                        align: 'center'
                    },
                    {
                        name: 'Active',
                        column: 'active',
                        boolean: true,
                        toggle: true,
                        align: 'center'
                    },
                    {
                        name: 'Hidden',
                        column: 'hidden',
                        boolean: true,
                        toggle: true,
                        align: 'center'
                    }
                ],
                actions: {
                    display: true,
                    class: [],
                    options: [
                        { label: 'Edit', link: 'edit', icon: 'edit', type: 'router-link', tooltip: 'Edit', permissions: this.resource+'.edit' },
                        { label: 'Delete', method: 'delete', icon: 'trash-alt', type: 'method', tooltip: 'Delete', permissions: this.resource+'.destroy' },
                    ]
                }
            }
        },
        methods: {
            methodHandler: function(method){
                this[method]();
            },
        },
        mounted() {
            //Search Filter
            const searchFilter = {
                label: 'Search',
                name: 'search',
                type: 'text',
                width: 'w-1/4',
                value: this.searchValue,
                placeholder: 'Search...'
            };

            this.filters.push(searchFilter);
        }
    }
</script>

<style scoped>

</style>
